import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    // Signal para reatividade
    private currentTheme = signal<'light' | 'dark'>('dark');

    // Getter público para o tema
    get theme() {
        return this.currentTheme();
    }

    constructor() {
        this.initTheme();
    }

    /**
     * Inicializa o tema a partir do localStorage ou usa dark como padrão
     */
    initTheme(): void {
        const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | null;
        const preferredTheme = savedTheme || 'dark';
        this.setTheme(preferredTheme);
    }

    /**
     * Define o tema e persiste no localStorage
     */
    setTheme(theme: 'light' | 'dark'): void {
        this.currentTheme.set(theme);
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }

    /**
     * Alterna entre light e dark
     */
    toggleTheme(): void {
        const newTheme = this.currentTheme() === 'dark' ? 'light' : 'dark';
        this.setTheme(newTheme);
    }

    /**
     * Retorna true se o tema atual é dark
     */
    isDark(): boolean {
        return this.currentTheme() === 'dark';
    }

    /**
     * Retorna true se o tema atual é light
     */
    isLight(): boolean {
        return this.currentTheme() === 'light';
    }
}
